// extracted by mini-css-extract-plugin
export default {"pageContainer":"Index_pageContainer__RYgzd","header":"Index_header__JxfxD","title":"Index_title__T2ovd","navbar":"Index_navbar__OI-ZJ","item":"Index_item__Rdb4x"};